<template>
  <b-row>
    <b-col
      cols="12"
      md="6"
    >
      <h2>Reservas</h2>
      <p>
        Sinta-se a vontade para fazer uma reserva, lembre-se de que cada {{ $t("app.reserva") }}
        tem suas regras e horários.
      </p>
    </b-col>
    <b-col
      cols="12"
      class="my-2 text-center"
    >
      <router-link to="/reservas/new">
        <b-button
          variant="outline-primary"
          class="w-100"
        >
          <feather-icon icon="PlusIcon" />
          Nova Reserva
        </b-button>
      </router-link>
    </b-col>
    <b-col cols="12">
      <b-tabs>
        <b-tab>
          <template #title>
            <feather-icon icon="HeartIcon" />
            <span>Minhas Reservas</span>
          </template>
          <list-minhas-reservas />
        </b-tab>
        <b-tab lazy>
          <template #title>
            <feather-icon icon="CalendarIcon" />
            <span>Todas</span>
          </template>
          <list-ultimas-reservas />
        </b-tab>
      </b-tabs>
    </b-col>
  </b-row>
</template>
<script>
import ListMinhasReservas from '../components/ListMinhasReservas.vue'
import ListUltimasReservas from '../components/ListUltimasReservas.vue'

export default {
  components: {
    ListUltimasReservas,
    ListMinhasReservas,
  },
}
</script>
